import { TemplateData, TemplateParams } from '.';

const newUser = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{createAccountUrl}}',
    buttonText: messages.createAccount,
    content: `
      <p>
        ${messages.newUserStartContentInvited}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.newUserInfo}
      </p>
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.newUserSubject}`
  },
  placeholders: {
    createAccountUrl: {
      label: messages.createAccountLink,
      example: `${serverConfig.adminUrl}/create-account?key=123`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeNewUser
});

export default newUser;
